import React from "react";

const CtaBand = () => {
  return (
    <section className="relative w-full overflow-hidden bg-[color:var(--navy)]">
      <div className="absolute inset-0">
        <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[color:var(--brand-accent)]/25 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 h-[30rem] w-[30rem] rounded-full bg-[color:var(--brand)]/30 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/25 to-black/45" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white">
            The Best Companies Never Stop Improving.
          </h2>

          <p className="mt-6 text-base sm:text-lg text-white/85">
            People-focused. Process-centric. Processes can’t work for you unless
            your people work with you.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center rounded-lg px-8 py-4 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95 transition shadow-lg"
            >
              Talk to Our Team
            </a>

            <a
              href="#services"
              className="inline-flex items-center justify-center rounded-lg px-8 py-4 text-sm font-semibold bg-white/15 text-white hover:bg-white/25 transition"
            >
              Explore Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
